import React from 'react';

export function InternationalTaxProfile() {
  return <p>Edit tax profile</p>;
}

export default InternationalTaxProfile;
